import React, {ReactElement, useEffect, useState} from "react";
import {Button, Col, Form, Row} from "react-bootstrap";
import { ReactSortable } from "react-sortablejs";
import {useLocation, useNavigate} from "react-router-dom";
import {objectToUrl, parseFilterParamsFromUrl} from "@src/helpers/utils.helper";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faUpDownLeftRight
} from "@fortawesome/pro-light-svg-icons";

interface TableColumnsProps {
    availableColumns: any,
    onColumnSelected?: Function
}

const TableColumns: React.FC<TableColumnsProps> = ({availableColumns, onColumnSelected}): ReactElement => {
    const navigate = useNavigate();
    const locationParams = useLocation().search;
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [availableToSelectColumns, setAvailableToSelectColumns] = useState([]);

    useEffect(() => {
        setSelectedColumns(() => availableColumns.filter(column => column.visible))
        setAvailableToSelectColumns(() => availableColumns.filter(column => !column.visible))

    }, [availableColumns]);


    const onApplyColumnsHandler = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        let columnParams= [];
        selectedColumns.map(column => columnParams.push(column.id));

        if (columnParams.length === 0){
            return;
        }

        const urlParams = {...parseFilterParamsFromUrl(locationParams), column: columnParams};
        const urlLink = '?' + objectToUrl(urlParams).split('&').filter(Boolean).join('&');

        navigate(urlLink);
        onColumnSelected && onColumnSelected();
    }

    return (
        <>
            <Form onSubmit={onApplyColumnsHandler} method="get">
                <Row className="mb-3">
                    <Col>
                        <ReactSortable
                            group="columns"
                            list={selectedColumns}
                            setList={setSelectedColumns}
                            tag={"ul"}
                            className="list-group list-group-column-select"
                            // handle=".item-move-handler"
                            ghostClass="bg-azure-lt"
                            animation={50}
                        >
                            {selectedColumns.map((item) => (
                                <li className="list-group-item" key={item.id}>
                                    <FontAwesomeIcon icon={faUpDownLeftRight} className="item-move-handler"/>
                                    {item.name}
                                </li>
                            ))}
                        </ReactSortable>
                    </Col>
                    <Col>
                        <ReactSortable
                            group="columns"
                            list={availableToSelectColumns}
                            setList={setAvailableToSelectColumns}
                            tag={"ul"}
                            className="list-group list-group-column-select"
                            // handle=".list-group"
                            ghostClass="bg-azure-lt"
                            animation={50}
                        >
                            {availableToSelectColumns.map((item) => (
                                <li className="list-group-item" key={item.id}>
                                    <FontAwesomeIcon icon={faUpDownLeftRight} className="item-move-handler"/>
                                    {item.name}
                                </li>
                            ))}
                        </ReactSortable>
                    </Col>

                </Row>

                <Button type="submit" variant={"primary"}>
                    Wybierz
                </Button>
            </Form>
        </>

    );
}

export default TableColumns;